import { UnreadDot } from '@lib/components'
import type React from 'react'
import { NavLink } from 'react-router-dom'

import { FolderLinkCls } from '../Folders'
import css from './styles.module.css'

interface Props {
  to: string
  label: string
  icon: React.FC
  // a coral dot on the right: something new behind the link
  unread?: boolean
  testId?: string
}

export const SidebarLink: React.FC<Props> = ({
  to,
  label,
  icon: Icon,
  unread = false,
  testId = '',
}) => (
  <NavLink to={to} className={FolderLinkCls.wrapper} data-testid={testId}>
    <div className={FolderLinkCls.icon}>
      <Icon />
    </div>
    <div className={FolderLinkCls.text}>
      <div className={FolderLinkCls.title}>{label}</div>
      {unread && <UnreadDot className={css.dot} />}
    </div>
  </NavLink>
)
